﻿import { useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Row, Col, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import classes from "../maintainers.module.scss";

import Head from "@/components/Content/Head";
import BasePagination from "@/components/Pagination/BasePagination";
import Fetching from "@/components/Fetching/Fetching";
import HauliersTableHead from "./HauliersTableHead";
import HauliersTableBody from "./HauliersTableBody";
import BasicConfirm from "@/components/Confirm/BasicConfirm";
import HauliersForm from "./HauliersForm/HauliersForm";

import { hasPermission } from "@/services/Utils";

import { useHauliersPaginate, useMutateHaulier, useMutateDeleteHaulier } from "@/hooks/maintainers/hauliers";
import { base_list } from "./hauliers.constants";

const Hauliers = () => {
	const { addToast } = useToasts();
	const { search, estate_parent_id, estate_id } = useSelector((state) => state.auth.filter);
	const { option } = useParams();
	const navigate = useNavigate();

	const [base, setBase] = useState({ ...base_list });
	const [showDelete, setShowDelete] = useState(false);
	const [selected, setSelected] = useState("");

	const { data, isLoading, isFetching } = useHauliersPaginate({
		...base,
		search,
		estate_parent_id,
		estate_id,
	});
	const { mutate: mutateSave, isLoading: isLoadingSave } = useMutateHaulier({
		...base,
		search,
		estate_parent_id,
		estate_id,
	});
	const { mutate: mutateDelete, isLoading: isLoadingDelete } = useMutateDeleteHaulier({
		...base,
		search,
		estate_parent_id,
		estate_id,
	});

	const { hauliers: list, estates_parents, estates, permissions } = data ? data : {};
	const { data: hauliers, last_page, total, from, to } = list ? list : {};

	const handleDelete = (item) => {
		setSelected(item.id);
		setShowDelete(true);
	};

	const confirmDelete = () => {
		mutateDelete(
			{ ...base, search, estate_parent_id, estate_id, selected },
			{
				onSuccess: () => {
					setSelected("");
					setShowDelete(false);
					addToast("Transportista eliminado correctamente.", {
						appearance: "success",
					});
				},
			},
		);
	};

	const confirmSave = (data) => {
		mutateSave(
			{ ...base, search, estate_parent_id, estate_id, params: { ...data } },
			{
				onSuccess: () => {
					addToast("Transportista guardado correctamente.", {
						appearance: "success",
					});
				},
			},
		);
	};

	const setPage = (value) => setBase({ ...base, page: value });
	const setOrder = (value) => setBase({ ...base, order: value });
	const setOrderType = (value) => setBase({ ...base, orderType: value });
	const setPaginate = (value) => setBase({ ...base, paginate: value });

	if (isLoading || isLoadingDelete) {
		return <Fetching />;
	}

	return (
		<>
			<Head
				title="Transportista"
				button={hasPermission("create", permissions) ? true : false}
				button_text={"Nuevo Transportista"}
				action={() => navigate("/configuracion/transportistas/crear")}
				back_url={"/configuracion?section=users"}
				isFetching={isFetching}
			/>

			{hasPermission("show", permissions) && (
				<Row className={` ${classes.main_row}`}>
					<Col md={12} className={classes.main_col}>
						<Row className={classes.table}>
							<div className={classes.table_div}>
								<Table className={classes.table_desktop}>
									<HauliersTableHead order={base.order} setOrder={setOrder} orderType={base.orderType} setOrderType={setOrderType} />

									<HauliersTableBody hauliers={hauliers} handleDelete={handleDelete} permissions={permissions} />
								</Table>
							</div>
						</Row>

						<BasePagination
							page={base.page}
							paginate={base.paginate}
							last_page={last_page}
							quantity={total}
							from={from}
							to={to}
							setPage={setPage}
							setPaginate={setPaginate}
						/>
					</Col>
				</Row>
			)}

			<BasicConfirm
				showConfirm={showDelete}
				setShowConfirm={setShowDelete}
				handleAction={confirmDelete}
				showValidation={true}
				textValidation={"eliminar transportista"}
			/>

			{option && (
				<HauliersForm
					confirmSave={confirmSave}
					isLoadingSave={isLoadingSave}
					estates_parents={estates_parents}
					estates={estates}
					permissions={permissions}
				/>
			)}
		</>
	);
};

export default Hauliers;
